import {
  CHANGE_STATUS_SURVEY_CONFIRM_DIALOG,
  CLOSED,
  IN_PROGRESS,
  NEW_SURVEY_STATUS,
  OBSOLETE,
  SENT,
  SHOW_CHANGE_STATUS_SURVEY_DIALOG,
  SHOW_SEND_SURVEY_DIALOG
} from "../../../ducks/statusOfSurvey";
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_AD, ROLE_AD_AS, ROLE_BL, ROLE_RL } from "../../../common/constant";
import React, { Component } from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

const SURVEY_COMPLETED = 100;

class StatusOfSurvey extends Component {
  constructor(props) {
    super(props);
    this.sendPDFToSap = this.sendPDFToSap.bind(this);
    this.openPDF = this.openPDF.bind(this);
    this.onConfirmChangeStatus = this.onConfirmChangeStatus.bind(this);
    this.onChangeStausOfSurveyProperty = this.onChangeStausOfSurveyProperty.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    const { loadAvailableWorkflowTransition } = this.props;
    loadAvailableWorkflowTransition();
  }

  close() {
    const { changeStatusOfSurveyProperty, showSendSurveyDialog } = this.props;
    showSendSurveyDialog
      ? changeStatusOfSurveyProperty(SHOW_SEND_SURVEY_DIALOG, false)
      : changeStatusOfSurveyProperty(SHOW_CHANGE_STATUS_SURVEY_DIALOG, false);
    changeStatusOfSurveyProperty(CHANGE_STATUS_SURVEY_CONFIRM_DIALOG, false);
  }

  //when user choose status to which survey should be changed
  onChangeStausOfSurveyProperty(status) {
    const { changeStatusOfSurveyProperty } = this.props;
    changeStatusOfSurveyProperty(CHANGE_STATUS_SURVEY_CONFIRM_DIALOG, true);
    changeStatusOfSurveyProperty(NEW_SURVEY_STATUS, status);
  }

  //confirmation for status changing
  onConfirmChangeStatus() {
    const { setNewStatusWorkflowTransition, newSurveyStatus } = this.props;
    setNewStatusWorkflowTransition(newSurveyStatus, CHANGE_STATUS_SURVEY_CONFIRM_DIALOG);
    this.close();
  }

  sendPDFToSap(SENT, SHOW_SEND_SURVEY_DIALOG) {
    const { setNewStatusWorkflowTransition } = this.props;
    setNewStatusWorkflowTransition(SENT, SHOW_SEND_SURVEY_DIALOG);
    this.close();
  }

  openPDF() {
    const { currentOverview, loadSurveyVersion } = this.props;
    loadSurveyVersion(currentOverview, currentOverview, false, true, true, false);
  }

  render() {
    const {
      showSendSurveyDialog,
      showChangeStatusSurveyDialog,
      changeStatusSurveyConfirmDialog,
      totalProgress,
      intl,
      possibleTransitions,
      readOnly,
      currentOverview
    } = this.props;
    let RL = currentOverview.roles?.includes(ROLE_RL);
    let BL = currentOverview.roles?.includes(ROLE_BL);
    let AD = currentOverview.roles?.includes(ROLE_AD) || currentOverview.roles?.includes(ROLE_AD_AS);
    return (
      <Modal className="status-of-survey-container" show={showSendSurveyDialog || showChangeStatusSurveyDialog}>
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage
              id={
                showSendSurveyDialog
                  ? RL || BL
                    ? "status.of.survey.send.dialog.title.RL"
                    : AD
                    ? "status.of.survey.send.dialog.title.AD"
                    : "status.of.survey.send.dialog.title"
                  : "respondents.detail.status.change"
              }
            />
          </Modal.Title>
        </Modal.Header>
        {showSendSurveyDialog ? (
          <Modal.Body>
            {totalProgress !== SURVEY_COMPLETED && !(RL || BL || AD) ? (
              <p>{intl.formatMessage({ id: "status.of.survey.send.dialog.info" }, { totalProgress })}</p>
            ) : null}
            <FormattedMessage
              id={
                RL || BL
                  ? "status.of.survey.send.dialog.text1.RL"
                  : AD
                  ? "status.of.survey.send.dialog.text1.AD"
                  : "status.of.survey.send.dialog.text1"
              }
            />
            <FormattedMessage
              id={
                RL || BL
                  ? "status.of.survey.send.dialog.text2.RL"
                  : AD
                  ? "status.of.survey.send.dialog.text2.AD"
                  : "status.of.survey.send.dialog.text2"
              }
            />
          </Modal.Body>
        ) : changeStatusSurveyConfirmDialog ? (
          <Modal.Body>
            <FormattedMessage id="status.of.survey.change.status.confirm.dialog.text" />
          </Modal.Body>
        ) : showChangeStatusSurveyDialog && possibleTransitions[OBSOLETE] ? (
          <Modal.Body>
            <FormattedMessage id="status.of.survey.change.status.dialog.obsolete.text1" />
            <FormattedMessage id="status.of.survey.change.status.dialog.obsolete.text2" />
          </Modal.Body>
        ) : showChangeStatusSurveyDialog ? (
          <Modal.Body>
            {
              //<FormattedMessage id="status.of.survey.change.status.dialog.text1"/>
            }
            {BL || AD ? (
              <FormattedMessage id="status.of.survey.change.status.dialog.text2.BL" />
            ) : (
              <FormattedMessage id="status.of.survey.change.status.dialog.text2" />
            )}
          </Modal.Body>
        ) : null}
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.openPDF()}>
            <FormattedMessage id="respondents.detail.pdf" />
          </Button>
          {showSendSurveyDialog && possibleTransitions[SENT] && !readOnly ? (
            <Button onClick={() => this.sendPDFToSap(SENT, SHOW_SEND_SURVEY_DIALOG)}>
              {RL ? (
                <FormattedMessage id="respondents.detail.submitButton.RL" />
              ) : BL ? (
                <FormattedMessage id="respondents.detail.submitButton.BL" />
              ) : AD ? (
                <FormattedMessage id="respondents.detail.submitButton.AD" />
              ) : (
                <FormattedMessage id="respondents.detail.submitButton" />
              )}
            </Button>
          ) : changeStatusSurveyConfirmDialog ? (
            <Button onClick={() => this.onConfirmChangeStatus()}>
              <FormattedMessage id="respondents.detail.status.change" />
            </Button>
          ) : showChangeStatusSurveyDialog && possibleTransitions[OBSOLETE] ? (
            <div className="change-status-survey-buttons">
              <Button onClick={() => this.onChangeStausOfSurveyProperty(OBSOLETE)}>
                <FormattedMessage id="respondents.detail.status.OBSOLETE" />
              </Button>
            </div>
          ) : showChangeStatusSurveyDialog ? (
            <div className="change-status-survey-buttons">
              {possibleTransitions[CLOSED] && (
                <Button onClick={() => this.onChangeStausOfSurveyProperty(CLOSED)}>
                  <FormattedMessage id="respondents.detail.status.CLOSED" />
                </Button>
              )}
              {possibleTransitions[IN_PROGRESS] && (
                <Button onClick={() => this.onChangeStausOfSurveyProperty(IN_PROGRESS)}>
                  <FormattedMessage id="respondents.detail.status.IN_PROGRESS" />
                </Button>
              )}
            </div>
          ) : null}
          <Button variant="secondary" onClick={() => this.close()}>
            <FormattedMessage id="app.common.Close" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

StatusOfSurvey.propTypes = {
  loadSurveyVersion: PropTypes.func,
  showSendSurveyDialog: PropTypes.bool,
  showChangeStatusSurveyDialog: PropTypes.bool,
  changeStatusSurveyConfirmDialog: PropTypes.bool,
  sent: PropTypes.bool,
  setNewStatusWorkflowTransition: PropTypes.func,
  loadAvailableWorkflowTransition: PropTypes.func,
  changeStatusOfSurveyProperty: PropTypes.func,
  newSurveyStatus: PropTypes.string,
  currentOverview: PropTypes.object
};
export default injectIntl(StatusOfSurvey);
